import { IChildProp } from "@intelligence/components/Form/type";
// import { TDataSource, TDataSourceMetrics, convertDataSourceAndSource } from "@intelligence/_config/dataSource";

// const PC_AND_CONSOLE_DATA_SOURCE: Record<TDataSource, TDataSourceMetrics[]> = {
//   // mscience: ['digitalRevenue', 'units', 'digitalARPPU', 'ast'],
//   // steamData: ['steamData_SteamPCU', 'steamData_SteamACU', 'steamData_SteamFollowers', 'steamData_SteamReviews', 'steamData_premiumRevenue', 'steamData_cumulativeRevenue', 'steamData_unit', 'steamData_cumulativeUnits', 'steamData_price', 'steamData_lifetimeWeightedPrice', 'steamData_playersByCountry', 'steamData_avgPlaytime', 'steamData_totalFollowers'],
//   // gsd: ['digitalUnitsGSD', 'physicalUnitsGSD', 'digitalRevenueGSD', 'physicalRevenueGSD'],
//   // npd: ['physicalRevenue', 'physicalUnits'],
//   // ampere: ['ampere_mau', 'ampere_previousMAU', 'ampere_addedMAU', 'ampere_newMAU', 'ampere_retainedMAU', 'ampere_churnedMAU', 'ampere_dau', 'ampere_newDAU', 'ampere_avgMonthlyPlaytimeAmpere', 'ampere_acquisitionRate', 'ampere_stickness', 'ampere_lifetimePlayers', 'ampere_avgDaillyPlaytime', 'ampere_d1', 'ampere_d7', 'ampere_d14', 'ampere_d28', 'ampere_d60', 'ampere_rollingD1', 'ampere_rollingD7', 'ampere_rollingD14', 'ampere_rollingD28', 'ampere_rollingD60'],
//   // hatchet: ['hoursWatched', 'airtime', 'peakCCV', 'avgCCV'],
//   // famitsu: ['famitsu_salesOfSelectedTime', 'famitsu_revenueOfSelectedTime', 'famitsu_cumulativeSales', 'famitsu_cumulativeRevenueFamitsu', 'famitsu_priceFamitsu'],
//   // noUpdate: ['mau', 'playerShare', 'mauGrowth', 'mauNew', 'mauReturning', 'lifetimePlayer', 'timeSpent0h','timeSpent1h', 'timeSpent5h', 'timeSpent10h', 'timeSpent25h', 'timeSpent50h', 'avgDailyPlaytime', 'avgDailySessions', 'avgPlaytimePerSession', 'avgMonthlyPlaytime', 'avgMonthlySessions', 'avgDaysPlayed', 'stickness', 'totalHours', 'churn', 'acquisition', 'retentionD1', 'retentionD2', 'retentionD4', 'retentionD7', 'retentionD14', 'retentionD28'],
//   revenue: ['digitalRevenue', 'digitalUnits', 'digitalARPPU', 'astSimple', 'physicalRevenue', 'physicalUnits', 'digitalUnitsGSD', 'physicalUnitsGSD', 'digitalRevenueGSD', 'physicalRevenueGSD'],
//   steamData: ['SteamPCU', 'SteamACU', 'steamFollowers', 'steamReviews', 'steamPrice_pcMetrics', 'steamRevenue_pcMetrics', 'steamCumulativeRevenue', 'steamUnits_pcMetrics', 'steamCumulativeUits'],
//   japanSales: ['famitsu_salesOfSelectedTime_pcconsole', 'famitsu_price_pcconsole', 'famitsu_revenueOfSelectedTime_pcconsole', 'famitsu_cumulativeSalesOfTheLatestWeek_pcconsole', 'famitsu_cumulativeRevenueOfTheLatestWeek_pcconsole'],
//   mau: ['ampere_mau', 'ampere_previousMAU', 'ampere_addedMAU', 'ampere_newMAU', 'ampere_retainedMAU', 'ampere_churnedMAU'],
//   dau: ['ampere_dau', 'ampere_newUsers'],
//   engagement: ['ampere_avgMonthlyPlaytimeAmpere', 'ampere_acquisition_rate', 'ampere_stickness', 'ampere_lifetimePlayers', 'ampere_avgDaillyPlaytime'],
//   retention: ['ampere_d1', 'ampere_d7', 'ampere_d14', 'ampere_d28', 'ampere_d60', 'ampere_rollingD1', 'ampere_rollingD7', 'ampere_rollingD14', 'ampere_rollingD28', 'ampere_rollingD60'],
//   noUpdate: ['mau', 'playerShare', 'mauGrowth', 'mauNew', 'mauReturning', 'lifetimePlayer', 'timeSpent0h','timeSpent1h', 'timeSpent5h', 'timeSpent10h', 'timeSpent25h', 'timeSpent50h', 'avgDailyPlaytime', 'avgDailySessions', 'avgPlaytimePerSession', 'avgMonthlyPlaytime', 'avgMonthlySessions', 'avgDaysPlayed', 'stickness', 'totalHours', 'churn', 'acquisition', 'retentionD1', 'retentionD2', 'retentionD4', 'retentionD7', 'retentionD14', 'retentionD28'],
// };

const PC_AND_CONSOLE_DOWNLOAD_SET: IChildProp[] =
  [{
    enumKey: 'singleMetrics',
    enumTargetType: 'downloadMainCategory',
    type: 'cascader',
    hasSelectAll: true,
    hasSearch: true,
    mainCategory: 'Metrics Category',
    subCategory: '<self>',
    children: [
      {
        enumKey: 'revenue',
        enumTargetType: 'dataSource',
        isNoIcon: true,
        children: [
          {
            enumKey: 'digitalRevenue',
          },
          {
            enumKey: 'digitalUnits',
          },
          {
            enumKey: 'digitalARPPU',
          },
          {
            enumKey: 'astSimple',
          },
          {
            enumKey: 'physicalRevenue',
            disableCondition: 'additionalFields:dateType:weekly||additionalFields:dateType:daily',
          },
          {
            enumKey: 'physicalUnits',
            disableCondition: 'additionalFields:dateType:weekly||additionalFields:dateType:daily',
          },
          {
            enumKey: 'digitalUnitsGSD',
            disableCondition: 'additionalFields:dateType:daily||additionalFields:dateType:monthly',
          },
          {
            enumKey: 'physicalUnitsGSD',
            disableCondition: 'additionalFields:dateType:daily||additionalFields:dateType:monthly',
          },
          {
            enumKey: 'digitalRevenueGSD',
            disableCondition: 'additionalFields:dateType:daily||additionalFields:dateType:monthly',
          },
          {
            enumKey: 'physicalRevenueGSD',
            disableCondition: 'additionalFields:dateType:daily||additionalFields:dateType:monthly',
          },
        ],
      },
      {
        enumKey: 'steamData',
        enumTargetType: 'dataSource',
        isNoIcon: true,
        children: [
          {
            enumKey: 'SteamPCU',
          },
          {
            enumKey: 'SteamACU',
          },
          {
            enumKey: 'steamFollowers',
          },
          {
            enumKey: 'steamReviews',
          },
          {
            enumKey: 'steamPrice_pcMetrics',
          },
          {
            enumKey: 'steamRevenue_pcMetrics',
          },
          {
            enumKey: 'steamCumulativeRevenue',
          },
          {
            enumKey: 'steamUnits_pcMetrics',
          },
          {
            enumKey: 'steamCumulativeUits',
          },
        ],
      },
      // Famitsu/Japan Sales is temporarily unavailable in PC&Console downloads.
      // {
      //   enumKey: 'japanSales',
      //   enumTargetType: 'dataSource',
      //   disableCondition: 'additionalFields:dateType:daily||additionalFields:dateType:monthly',

      //   children: [
      //     {
      //       enumKey: 'famitsu_salesOfSelectedTime_pcconsole',
      //     },
      //     {
      //       enumKey: 'famitsu_price_pcconsole',
      //     },
      //     {
      //       enumKey: 'famitsu_revenueOfSelectedTime_pcconsole',
      //     },
      //     {
      //       enumKey: 'famitsu_cumulativeSalesOfTheLatestWeek_pcconsole',
      //     },
      //     {
      //       enumKey: 'famitsu_cumulativeRevenueOfTheLatestWeek_pcconsole',
      //     },
      //  ],
      // },
      {
        enumKey: 'mau',
        enumTargetType: 'dataSource',
        isNoIcon: true,
        disableCondition: 'additionalFields:dateType:weekly||additionalFields:dateType:daily',
        children: [
          {
            enumKey: 'ampere_mau',
          },
          {
            enumKey: 'ampere_previousMAU',
          },
          {
            enumKey: 'ampere_addedMAU',
          },
          {
            enumKey: 'ampere_newMAU',
          },
          {
            enumKey: 'ampere_retainedMAU',
          },
          {
            enumKey: 'ampere_churnedMAU',
          },
        ],
      },
      {
        enumKey: 'dau',
        enumTargetType: 'dataSource',
        isNoIcon: true,
        disableCondition: 'additionalFields:dateType:weekly||additionalFields:dateType:monthly',
        children: [
          {
            enumKey: 'ampere_dau',
          },
          {
            enumKey: 'ampere_newUsers',
          },
        ],
      },
      {
        enumKey: 'engagement',
        enumTargetType: 'dataSource',
        isNoIcon: true,
        disableCondition: 'additionalFields:dateType:weekly',
        children: [
          {
            enumKey: 'ampere_avgMonthlyPlaytimeAmpere',
            disableCondition: 'additionalFields:dateType:daily',
          },
          {
            enumKey: 'ampere_acquisitionRate',
            disableCondition: 'additionalFields:dateType:daily',
          },
          {
            enumKey: 'ampere_stickness',
            disableCondition: 'additionalFields:dateType:daily',
          },
          {
            enumKey: 'ampere_lifetimePlayers',
            disableCondition: 'additionalFields:dateType:daily',
          },
          {
            enumKey: 'ampere_avgDaillyPlaytime',
            disableCondition: 'additionalFields:dateType:monthly',
          },
        ],
      },
      {
        enumKey: 'retention',
        enumTargetType: 'dataSource',
        isNoIcon: true,
        disableCondition: 'additionalFields:dateType:weekly||additionalFields:dateType:monthly',
        children: [
          {
            enumKey: 'ampere_d1',
          },
          {
            enumKey: 'ampere_d7',
          },
          {
            enumKey: 'ampere_d14',
          },
          {
            enumKey: 'ampere_d28',
          },
          {
            enumKey: 'ampere_d60',
          },
          {
            enumKey: 'ampere_rollingD1',
          },
          {
            enumKey: 'ampere_rollingD7',
          },
          {
            enumKey: 'ampere_rollingD14',
          },
          {
            enumKey: 'ampere_rollingD28',
          },
          {
            enumKey: 'ampere_rollingD60',
          },
        ],
      },
      {
        enumKey: 'noUpdate',
        enumTargetType: 'dataSource',
        isNoIcon: true,
        disableCondition: 'additionalFields:dateType:weekly||additionalFields:dateType:daily',
        children: [
          {
            enumKey: 'mau',
          },
          {
            enumKey: 'playerShare',
          },
          {
            enumKey: 'mauGrowth',
          },
          {
            enumKey: 'mauNew',
          },
          {
            enumKey: 'mauReturning',
          },
          {
            enumKey: 'lifetimePlayer',
          },
          {
            enumKey: 'timeSpent0h',
          },
          {
            enumKey: 'timeSpent1h',
          },
          {
            enumKey: 'timeSpent5h',
          },
          {
            enumKey: 'timeSpent10h',
          },
          {
            enumKey: 'timeSpent25h',
          },
          {
            enumKey: 'timeSpent50h',
          },
          {
            enumKey: 'avgDailyPlaytime',
          },
          {
            enumKey: 'avgDailySessions',
          },
          {
            enumKey: 'avgPlaytimePerSession',
          },
          {
            enumKey: 'avgMonthlyPlaytime',
          },
          {
            enumKey: 'avgMonthlySessions',
          },
          {
            enumKey: 'avgDaysPlayed',
          },
          {
            enumKey: 'stickness',
          },
          {
            enumKey: 'totalHours',
          },
          {
            enumKey: 'churn',
          },
          {
            enumKey: 'acquisition',
          },
          {
            enumKey: 'retentionD1',
          },
          {
            enumKey: 'retentionD2',
          },
          {
            enumKey: 'retentionD4',
          },
          {
            enumKey: 'retentionD7',
          },
          {
            enumKey: 'retentionD14',
          },
          {
            enumKey: 'retentionD28',
          },
        ],
      },
    ],
  },
  {
    enumKey: 'basicInformation',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'hasCompany',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGenre',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRelease',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasSteamId',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasMetaCriticScore',
      enumTargetType: 'downloadBasicInfo',
      // 值类型是布尔，其他都是0和1。。。。
      valueType: 'boolean',
    }, {
      enumKey: 'hasSteamTags',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGameMode',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGameEngine',
      enumTargetType: 'downloadBasicInfo',
    }],
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [{
      enumKey: 'timeSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        enumKey: 'isTimeAggregated',
        enumTargetType: 'downloadDataCalcu',
        defaultSelectCondition: 'additionalFields:tabType:countries',
      }, {
        enumKey: 'isByTime',
        enumTargetType: 'downloadDataCalcu',
        defaultSelectCondition: 'additionalFields:tabType:stats||additionalFields:tabType:kpiTrends',
      }]
    }, {
      enumKey: 'regionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        enumKey: 'isCountryAggregated',
        enumTargetType: 'downloadDataCalcu',
        defaultSelectCondition: 'additionalFields:tabType:stats||additionalFields:tabType:kpiTrends',
      }, {
        enumKey: 'isByCountries',
        enumTargetType: 'downloadDataCalcu',
        defaultSelectCondition: 'additionalFields:tabType:countries',
      }, {
        enumKey: 'isByRegion',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'special_platformSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isSegmentAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isBySegment',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'ratio',
      enumTargetType: 'downloadMainCategory',
      type: 'switch',
      isDefault: true,
    }],
  }, {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportAllData',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'selectTop',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportSelected',
      enumTargetType: 'downloadOther',
    }]
  }, {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  }, {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportExcel',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportCSV',
      enumTargetType: 'downloadOther',
    }],
  }];

export default {
  pcAndConsole: PC_AND_CONSOLE_DOWNLOAD_SET
};
